module.exports = __webpack_public_path__ + "static/media/ico_simulation_noseratio.ba0850ff.png";